import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PagePerformanceProfileService } from '@client/app/services/entities/page-performance/page-performance-profile.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import { isEqual } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class PagePerformanceProfileObsService {
    private profiles: any[] | null = null;
    private intervalKey: any = null;
    public profilesObs = new BehaviorSubject<any[]>([]);

    constructor (
        private pagePerformanceProfileService: PagePerformanceProfileService,
    ) {}

    startLiveReload (): void {
        this.disposeProfiles();
        this.setupWatchers();
    }

    disposeProfiles (): void {
        if (this.intervalKey) {
            clearInterval(this.intervalKey);
            this.intervalKey = null;
        }
        this.setProfiles([]);
    }

    addProfile (profile: any): any {
        if (!this.isRunning() || !Array.isArray(this.profiles)) {
            return profile;
        }
        this.profiles.push(profile);
        this.setProfiles(this.profiles);
        return profile;
    }

    removeProfile (profile: any): void {
        if (!this.isRunning() || !Array.isArray(this.profiles)) {
            return;
        }
        const index = this.profiles.findIndex(p => isEqual(p.id, profile.id));
        if (index > -1) {
            this.profiles.splice(index, 1);
            this.setProfiles(this.profiles);
        }
    }

    updateProfile (profile: any): any {
        if (!this.isRunning() || !Array.isArray(this.profiles)) {
            return profile;
        }
        const index = this.profiles.findIndex(p => isEqual(p.id, profile.id));
        if (index > -1) {
            this.profiles[index] = { ...this.profiles[index], ...profile };
            this.setProfiles(this.profiles);
        }
        return profile;
    }

    private setupWatchers (): void {
        if (this.isRunning()) {
            return;
        }

        this.startInterval();
        this.getProfiles().then(
            profiles => this.setProfiles(profiles),
            () => { /* noop */ },
        );
    }

    private setProfiles (profiles: any[]): void {
        this.profiles = profiles;
        this.profilesObs.next(profiles);
    }

    private getProfiles (): Promise<any[]> {
        const params = {
            page: 1,
            page_size: 0,
        };
        return this.pagePerformanceProfileService.getAll(params, contextTokens.NO_GLOBAL);
    }

    private startInterval (): void {
        this.intervalKey = setInterval(() => {
            this.getProfiles().then(
                profiles => this.setProfiles(profiles),
                () => { /* noop */ },
            );
        }, 900000); // 15 minutes
    }

    private isRunning (): boolean {
        return this.intervalKey !== null;
    }
}
